import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, SmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { DECO_COOKIE, OFFER_SUMMARY } from './salesData';

/**
 * PRIMERA revelación del precio de toda la carta. El CTA del hero
 * (#oferta) hace smooth-scroll exactamente hasta acá.
 *
 * La card es deliberadamente compacta: precio en línea, beneficios en dos
 * columnas y el CTA a pocos píxeles del precio.
 */
export function OfferSection() {
  return <section id="oferta" className="relative scroll-mt-24 overflow-hidden bg-[#E9F0D5] py-14 sm:py-20" aria-labelledby="offer-title" data-id="element-279" data-mp="rdwp1i1ast54">
      <div className="relative mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-280" data-mp="wchhgvab68j0">
        <div className="flex flex-col items-center text-center" data-id="element-281" data-mp="2t62psd0os64j">
          <SectionTag className="bg-white/70" data-id="element-282" data-mp="2y4cq1219pwx0">El precio</SectionTag>
          <h2 id="offer-title" className="mt-4 font-display text-[1.95rem] leading-[1.08] text-charcoal sm:text-[2.7rem]" data-id="element-283" data-mp="2y4meumakty14">
            100 recetas. Un solo pago.
          </h2>
        </div>

        <div className="relative mt-7 rounded-5xl bg-white p-5 shadow-bakery sm:mt-9 sm:p-8" data-id="element-284" data-mp="sxp02fvq3on4">
          {/* Cookie que rompe el borde superior de la card. */}
          <img src={DECO_COOKIE} alt="" aria-hidden loading="lazy" className="absolute -right-4 -top-7 h-[4.5rem] w-[4.5rem] rotate-6 rounded-full object-cover shadow-bakery sm:-right-8 sm:-top-10 sm:h-24 sm:w-24" data-id="element-285" data-mp="oxomexgg7hh4" />

          <div className="flex flex-col items-center gap-2.5 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-286" data-mp="1ckd8zwgejy42">
            <p className="max-w-sm font-display text-[1.08rem] leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-287" data-mp="17mbqbcmw20t4">
              100 New York Cookies + 5 bonos
            </p>
            <div className="flex shrink-0 items-center gap-2" data-id="element-288" data-mp="3sbsqbs7ws77z">
              <span className="rounded-full bg-charcoal px-3.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.1em] text-white sm:text-[0.66rem]" data-id="element-289" data-mp="3ttzpe16nq0ki">
                2 tomos
              </span>
              <span className="font-sans text-sm font-bold text-caramel" aria-hidden data-id="element-290" data-mp="3ktl3p0ps6jgh">
                +
              </span>
              <span className="rounded-full bg-[#F47A2A] px-3.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.1em] text-white sm:text-[0.66rem]" data-id="element-291" data-mp="3otva2ehhjbvv">
                5 bonos
              </span>
            </div>
          </div>

          <div className="mt-5 rounded-4xl bg-ivory px-4 py-5 sm:px-6" data-id="element-292" data-mp="3fwb7913z57j5">
            <PriceBlock size="lg" data-id="element-293" data-mp="316n3lt8blws9" />
          </div>

          <div className="mt-5 flex items-baseline gap-3" data-id="element-294" data-mp="364exutwftuzm">
            <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-[#F47A2A]" data-id="element-295" data-mp="364yi4h9k8vgt">
              Incluye
            </p>
            <span className="h-px flex-1 bg-warm" aria-hidden data-id="element-296" data-mp="2x3h3727w2ztp" />
          </div>
          <ul className="mt-3 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-297" data-mp="2x5jqvflkkgv9">
            {OFFER_SUMMARY.map(item => <li key={item} className="flex items-start gap-2" data-id="element-298" data-mp="28j3whayuhmo9">
                <span className="mt-[0.2rem] flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-pistacho" aria-hidden data-id="element-299" data-mp="28koq8ydc51l2">
                  <CheckIcon className="h-2.5 w-2.5 text-white" data-id="element-300" data-mp="2ifgqyb27s4k2" />
                </span>
                <span className="font-sans text-[0.84rem] font-medium leading-snug text-charcoal/85" data-id="element-301" data-mp="2wfi0eewjokb5">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-302" data-mp="365b1glz29h15">
            <CTAButton label="Sí, quiero mis 100 New York Cookies" size="lg" className="w-full" data-id="element-303" data-mp="368p6y330u6ct" />

            <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5" data-id="element-304" data-mp="3f8c7kmnxf84t">
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-305" data-mp="3a990kwodyru7">
                <LockIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-306" data-mp="18i8uzlsbdg44" /> Pago seguro
              </li>
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-307" data-mp="1dgk4twilzqmc">
                <ZapIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-308" data-mp="1iay3q8whcfvr" /> Acceso inmediato
              </li>
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-309" data-mp="1mc9kdoxdlqrt">
                <SmartphoneIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-310" data-mp="uize0jwaahz3" /> Producto
                digital
              </li>
              <li className="flex items-center gap-1.5 font-sans text-[0.72rem] font-semibold text-charcoal-mid" data-id="element-311" data-mp="yk2tv6ec0e0b">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-[#F47A2A]" aria-hidden data-id="element-312" data-mp="13liewygiekip" /> Garantía de
                7 días
              </li>
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center font-sans text-[0.78rem] leading-relaxed text-charcoal-mid" data-id="element-313" data-mp="2exszwip0hccl">
          Producto 100% digital: no se envía nada físico. Los resultados de venta dependen de la
          ejecución, la presentación y el mercado de cada persona.
        </p>
      </div>
    </section>;
}